import { useRef } from "react";
import { useParams } from "react-router-dom";
import { Card, Flex, Spin } from "antd";
import { Button, Icon } from "ui";
import { useGetArticleDetails, useUpdateArticle } from "pages/articles/api";
import { isObjectEmpty } from "core/utils/json-utils";
import ArticleBaseForm, { ArticleFormRef } from "./form";

import styles from "./index.module.scss";
const BaseTab = () => {
  const formRef = useRef<ArticleFormRef>(null);

  const { id: articleId } = useParams();
  const { data, isPending: loadingArticle } = useGetArticleDetails({ queryKey: [{ id: articleId }] });

  const { mutate, isPending: updating } = useUpdateArticle();

  const addSection = () => {
    if (!formRef.current) return;

    // Get validation and form values
    const { validation, values } = formRef.current.getFormData();
    validation.then((result) => {
      // If no errors, then data is valid
      if (isObjectEmpty(result)) {
        mutate(
          {
            data: values!,
          },
          {
            onSuccess: () => {
              formRef.current?.resetForm();
            },
          }
        );
      }
    });
  };

  return (
    <>
      <Card bordered={false} style={{ overflow: 'hidden' }}>
        {loadingArticle ? (
          <Flex vertical gap={20} align="center" className={styles.loading_container}>
            <Spin size="large" />
            <span className="color-stroke">در حال بارگذاری...</span>
          </Flex>
        ) : (
          <>
            <ArticleBaseForm formData={data} ref={formRef} />
            <Button
              className={styles.form_button}
              onClick={() => addSection()}
              loading={updating || loadingArticle}
            >
              <Icon type="sr-check" />
              <span>ذخیره تغییرات</span>
            </Button>
          </>
        )}
      </Card>
    </>
  );
};

export default BaseTab;
